import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material"
import { TruncatedTypography } from "lib/@components/truncated-typography"

export function OptOutNewScheduleItem({ item, selections = {}, onToggle }) {
    const { id, title, code } = item ?? {}
    const checked = !!selections[id]

    return (
        <FormControlLabel
            sx={{ display: "flex", ml: 0 }}
            control={
                <Checkbox
                    checked={checked}
                    onChange={() => onToggle(id)}
                    data-cy={`opt-out-new-schedule-checkbox-${id}`}
                />
            }
            label={
                <Stack direction="row" spacing={1} alignItems="center">
                    <TruncatedTypography>{title}</TruncatedTypography>
                    <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
                        #{code}
                    </Typography>
                </Stack>
            }
        />
    )
}
